import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rims-and-tyres',
  templateUrl: './rims-and-tyres.component.html',
  styleUrls: ['./rims-and-tyres.component.scss']
})
export class RimsAndTyresComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
